import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class FacilityWaitingListsApi extends Api {
  constructor() {
    super('facility/waiting_lists/');
  }
}

export default FacilityWaitingListsApi;
